var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: _vm.size,
        height: _vm.size,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("path", {
        attrs: {
          d:
            "M12 2C6.48 2 2 6.15001 2 11.26C2 14.16 3.43999 16.74 5.67999 18.44V20.29C5.67999 21.06 6.49998 21.54 7.16998 21.16L9.03003 20.11C9.97003 20.38 10.96 20.52 11.99 20.52C17.51 20.52 21.99 16.37 21.99 11.26C22 6.15001 17.52 2 12 2ZM15.51 10.44L13.01 13.43C12.85 13.62 12.59 13.66 12.38 13.54L11.37 12.95C11.26 12.89 11.13 12.87 11 12.9L8.98999 13.39C8.51999 13.5 8.17999 12.95 8.48999 12.58L11.03 9.56C11.18 9.38 11.44 9.33 11.65 9.44L12.83 10.06C12.94 10.12 13.07 10.13 13.19 10.1L15.01 9.63C15.47 9.51 15.82 10.07 15.51 10.44Z",
          fill: _vm.color
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }